import { ReactComponent as PlusSvg } from '../../../../assets/icons/Plus.svg';

import { createIconComponent } from './createIconComponent';

export const PlusIcon = createIconComponent(PlusSvg);
